var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmpionCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 9,
    fill: "#D94D00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2829 18.9018L19.8829 15.0464C20.0391 14.9155 20.0391 14.7032 19.8829 14.5723L19.3172 14.0982C19.161 13.9673 18.9077 13.9673 18.7515 14.0982L15 17.2424L13.2485 15.7744C13.0923 15.6435 12.8391 15.6435 12.6828 15.7744L12.1172 16.2485C11.9609 16.3795 11.9609 16.5917 12.1172 16.7227L14.7172 18.9018C14.8734 19.0327 15.1266 19.0327 15.2829 18.9018Z",
    fill: "#071112"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpionCheck);
export default __webpack_public_path__ + "static/media/empion_check.47871a9c38d0fff6974f8e9c835dbb42.svg";
export { ForwardRef as ReactComponent };